import React, { Fragment, Component, h} from "preact";
import './Loading.scss'

export default function Loading({label}){
    return <p className="loading-container">
        <div className="loading-text"> {label} </div>
    </p>
}